import { useQuery } from '@tanstack/react-query'
import API from '../../../utils/api'

export const useBanks = () => {
  return useQuery(
    ['/banks'],
    async () => {
      return (await API.fetchCashoutBanks())?.data?.banks || []
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )
}
